import { Logo } from '@loomhq/lens';
import React from 'react';

import styles from './styles.module.less';

const LoomBadge = ({ href, title }) => (
  <a className={styles.loomBadgeWrapper} href={href} title={title}>
    <span className={styles.loomBadgeText}>Made with</span>
    <Logo
      className={styles.loomBadgeLogo}
      maxWidth="4.25em"
      symbolColor="body"
      wordmarkColor="body"
    />
  </a>
);

export default LoomBadge;
